import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  DirectionEnum,
  errors,
  isBeforeTimeString,
  isValidTimeString,
  MAIN_TIME_FORMAT,
  TNewNeighborAreaSettingsForm,
  TTimeHHmm,
  yupLocalized,
} from "@ryde/shared";

export const useNeighborAreasValidation = () => {
  const { t } = useTranslation();
  const neighborFormValidationSchema = useMemo(() => {
    return yupLocalized.object<TNewNeighborAreaSettingsForm>().shape({
      areaId: yupLocalized.number().required(),
      maxAreaSeats: yupLocalized
        .number()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value,
        )
        .nullable()
        .optional(),
      direction: yupLocalized
        .mixed<DirectionEnum>()
        .oneOf(Object.values(DirectionEnum)),
      fromTime: yupLocalized
        .mixed<TTimeHHmm>()
        .test(
          "is-valid-date",
          "Invalid date",
          value => value && isValidTimeString(value, MAIN_TIME_FORMAT),
        )
        .test(
          "isBeforeTest",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          (fromTime, ctx) => {
            const { toTime } = ctx.parent;

            if (!toTime || !fromTime) {
              return true;
            }

            return isBeforeTimeString(fromTime, toTime);
          },
        ),
      toTime: yupLocalized
        .mixed<TTimeHHmm>()
        .test(
          "is-valid-date",
          "Invalid date",
          value => value && isValidTimeString(value, MAIN_TIME_FORMAT),
        )
        .test(
          "isBeforeTest",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          (toTime, ctx) => {
            const { fromTime } = ctx.parent;

            if (!toTime || !fromTime) {
              return true;
            }

            return isBeforeTimeString(fromTime, toTime);
          },
        ),
      dayGroupIds: yupLocalized.array().of(yupLocalized.number()).optional(),
      dayTypeIds: yupLocalized.array().of(yupLocalized.number()).optional(),
      siteIds: yupLocalized.array().of(yupLocalized.number()).optional(),
    });
  }, [t]);
  return { neighborFormValidationSchema };
};
